// ===========================================
// MOBILE MENU FUNCTIONALITY
// ===========================================

document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.querySelector(".hamburger-wrapper");
  const hamburger = document.querySelector(".hamburger");
  const mobileMenu = document.querySelector("#mobile-menu");
  const closeButton = mobileMenu ? mobileMenu.querySelector(".mobile-menu-close") : null;
  const body = document.body;

  // Must match $breakpoint-nav in _variables.scss
  const desktopBreakpoint = 1200;

  if (!toggle || !hamburger || !mobileMenu) {
    return;
  }

  function isOpen() {
    return mobileMenu.classList.contains("is-active");
  }

  function focusableItems() {
    return mobileMenu.querySelectorAll("a[href], button:not([disabled])");
  }

  function openMobileMenu() {
    hamburger.classList.add("is-active");
    mobileMenu.classList.add("is-active");
    body.classList.add("menu-open");
    toggle.setAttribute("aria-expanded", "true");
    hamburger.textContent = hamburger.dataset.labelClose;

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeMobileMenu(returnFocus) {
    if (!isOpen()) {
      return;
    }

    hamburger.classList.remove("is-active");
    mobileMenu.classList.remove("is-active");
    body.classList.remove("menu-open");
    toggle.setAttribute("aria-expanded", "false");
    hamburger.textContent = hamburger.dataset.labelOpen;

    if (returnFocus) {
      toggle.focus();
    }
  }

  toggle.addEventListener("click", function () {
    if (isOpen()) {
      closeMobileMenu(true);
    } else {
      openMobileMenu();
    }
  });

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      closeMobileMenu(true);
    });
  }

  mobileMenu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", function () {
      closeMobileMenu(false);
    });
  });

  document.addEventListener("keydown", function (e) {
    if (!isOpen()) {
      return;
    }

    if (e.key === "Escape") {
      closeMobileMenu(true);
      return;
    }

    // Keep keyboard focus inside the open menu.
    if (e.key === "Tab") {
      const items = focusableItems();
      const first = items[0];
      const last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  window.addEventListener("resize", function () {
    if (window.innerWidth >= desktopBreakpoint) {
      closeMobileMenu(false);
    }
  });
});
